import { _js } from '@ifixit/localize';
import { Redo } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const RedoButton = (props: any) => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().redo().run()}
         isDisabled={!editor.can().redo()}
         icon={<Redo />}
         title={_js('Redo')}
         shortcut={'y'}
      ></TiptapButton>
   );
};
